<template>
	<div class="transcription-itemized-summary">
		<h1 class="title">{{ title }}</h1>
		<ul class="list itemized-list" v-if="keyDetails.length || actionItems.length">
			<li class="list-item" v-if="keyDetails.length">
				<h2 class="subtitle">{{ translate( `keyDetailsLabel` ) }}</h2>
				<ul class="list key-details-list">
					<li v-for="point in keyDetails" :key="point">
						{{ point }}
					</li>
				</ul>
			</li>
			<li class="list-item" v-if="actionItems.length">
				<h2 class="subtitle">{{ translate( `actionItemsLabel` ) }}</h2>
				<!-- FEATUREFLAG -->
				<ul :class="$config().enableRecommendedActionItems ? `list action-item-list` : `list`">
					<li :class="$config().enableRecommendedActionItems ? `list-item action-item-list-item` : `list-item`"
						v-for="item in actionItems"
						:key="item"
					>
						<AddButton
							v-if="$config().enableRecommendedActionItems"
							:title="translate( `copyToNoteLabel` )"
							size="TINY"
							type="SECONDARY"
							@click="$emit( `recommendActionItem`, { text: item } )"
						/>{{ item }}
					</li>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script>
import {
	AddButton,
	TranslateMixin
} from "@teaming/common-ui";

export default {
	name: "TranscriptionItemizedSummary",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [ "recommendActionItem", ],
	components: {
		AddButton,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		keyDetails: {
			type: Array,
			required: true,
		},
		actionItems: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
$textColor: $color1-700;

.transcription-itemized-summary {
	display: flex;
	flex-direction: column;
	gap: 0.2rem;

	color: $textColor;
}

.transcription-itemized-summary .title {
	@include font-and-line-for(1);
	font-weight: 600;
}

.transcription-itemized-summary .subtitle,
.transcription-itemized-summary .list-item {
	@include font-and-line-for(0);
	font-weight: 450;
}

.transcription-itemized-summary .list {
	margin: 0 0 0 1.2rem;
	padding: 0;
}

.transcription-itemized-summary .itemized-list {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.transcription-itemized-summary .action-item-list {
	display: flex;
	flex-direction: column;
	gap: 0.1rem;
	margin-left:0;
}

.transcription-itemized-summary .action-item-list-item {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
}
</style>
